"use client";

import React from "react";
import { Facebook, Instagram, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="223221" className="grid grid-cols-2 gap-8">
        <div className="space-y-4">
          {[1, 2].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded bg-muted" />)}
        </div>
        <div className="space-y-4">
          {[1, 2].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded bg-muted" />)}
        </div>
      </div>;
  }
  const itemsToRender = menuItems.length > 0 ? menuItems : [{
    id: 'fallback-1',
    label: 'Home',
    href: '/HomePage'
  }, {
    id: 'fallback-2',
    label: 'Our Services',
    href: '#'
  }, {
    id: 'fallback-3',
    label: 'About Us',
    href: '/AboutOurTeamPage'
  }, {
    id: 'fallback-4',
    label: 'Book Now',
    href: '/BookYourCleanPage'
  }];
  const half = Math.ceil(itemsToRender.length / 2);
  const col1 = itemsToRender.slice(0, half);
  const col2 = itemsToRender.slice(half);
  return <div className="grid grid-cols-2 gap-8">
      <ul className="space-y-4">
        {col1.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>
      <ul className="space-y-4">
        {col2.map((item, i) => <li key={item.id} data-index={i}>
            <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>
    </div>;
}
export default function Footer() {
  const socialLinks = [{
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }, {
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }];
  return <section id="footer" className="dark bg-background text-foreground px-6 py-16 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          
          {}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/loaf_logo_light.png" alt="Coastal Cleaning of Vero Beach" className="h-10 w-auto object-contain" />
            </Link>
            <p className="mt-8 max-w-sm text-sm leading-relaxed text-muted-foreground">
              Serving Vero Beach since 2018. We provide premium residential, commercial, and vacation rental turnover services with a focus on trust and coastal clarity.
            </p>
          </div>

          {}
          <div className="lg:col-span-4 lg:mx-auto">
            <h3 className="font-default mb-8 text-lg font-medium tracking-wide">Quick Links</h3>
            <MenuProvider menu_id="42">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:col-span-4 lg:ml-auto">
            <div className="mb-8">
              <h3 className="font-default mb-4 text-lg font-medium tracking-wide">Visit Us</h3>
              <p className="text-sm text-muted-foreground">Vero Beach, FL</p>
            </div>
            
            <div className="mb-8">
              <h3 className="font-default mb-4 text-lg font-medium tracking-wide">Service Hours</h3>
              <p className="text-sm leading-relaxed text-muted-foreground">
                Mon-Fri: 8:00am - 5:00pm<br />
                Sat: 9:00am - 2:00pm
              </p>
            </div>

            <div className="flex items-center gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} data-index={i} to={social.href} className="flex size-10 items-center justify-center rounded-full border border-primary/20 text-primary transition-colors hover:bg-accent hover:text-accent-foreground">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        {}
        <div className="mt-24">
          <Separator className="bg-border/20" />
          <div className="mt-8 flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="font-default text-[10px] uppercase tracking-widest text-muted-foreground">
              © {new Date().getFullYear()} Coastal Cleaning of Vero Beach. All rights reserved.
            </p>
            <p className="font-default text-[10px] uppercase tracking-widest text-muted-foreground">
              Vero Beach, Florida
            </p>
          </div>
        </div>
      </div>
    </section>;
}